const addconsents = {
    feilds: [{
        id: 1,
        name: 'investigations',
        text: 'Investigations',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Select Investigations',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Investigations'
            }
        ],
        errors: [],
        value: [],
        valid: false,
        state: '',
        disable: false,
        className: 'col-8 mb-4 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'procedures',
        text: 'Procedures',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Procedures',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Procedures'
            }
        ],
        errors: [],
        value: [],
        valid: false,
        state: '',
        disable: false,
        className: 'col-8 mb-4 d-flex pr-1 pl-2'
    }, {
        id: 2,
        name: 'drug',
        text: 'Drug',
        visible: true,
        element: 'select2multiple',
        required: true,
        input_type: 'select',
        placeholder: 'Drug',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Druge'
            }
        ],
        errors: [],
        value: [],
        valid: false,
        state: '',
        disable: false,
        className: 'col-8 mb-4 d-flex pr-1 pl-2'
    }, 
    {
        id: 1,
        name: 'search',
        text: 'IP or UMR No:',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'input',
        placeholder: 'Patient’s Name or IP Number',
        icon: 'user',
        rules: [
            {
                // test: (value) => {
                //     return (value !== null && value.length > 0);
                // },
                // message: 'Please Select Your Appointment Date'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-8 d-flex pr-1 pl-2'
    },
    ]
}
export {addconsents};